// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue';
import MapsApiBaseService from './MapsApiBaseService';

export default class InfoWindowService extends MapsApiBaseService {
  #infoWindow = null;

  async init() {
    await super.init();
    this.#infoWindow = this.createInfoWindow();
  }

  createInfoWindow(content) {
    return new this.googleMaps.InfoWindow({ content });
  }

  // eslint-disable-next-line class-methods-use-this
  getInfoWindowTemplate(template, props) {
    const InfoWindow = Vue.extend(template);
    const instance = new InfoWindow({ propsData: props });

    instance.$mount();

    return instance.$el;
  }

  openInfoWindow({
    map, marker, component, prepareProps,
  }) {
    const content = document.createElement('div');
    const infoWindow = this.getInfoWindowTemplate(component, prepareProps());

    content.appendChild(infoWindow);
    this.#infoWindow.setContent(content);
    this.#infoWindow.open(map, marker);
  }
}
